import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgForOf } from '@angular/common';

export type ButtonToggleOption = {
  label: string;
  value: any;
};

@Component({
  selector: 'app-button-toggle',
  standalone: true,
  templateUrl: './button-toggle.component.html',
  styleUrls: ['./button-toggle.component.scss'],
  imports: [NgForOf],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonToggleComponent {
  @Input() toggleOptions: ButtonToggleOption[] = [];
  /** Keys this toggle's inputs apart from any other toggle rendered at the same time. */
  @Input() controlIdPrefix = 'toggle';
  @Input() selectedValue!: any;
  @Input() disabled: boolean = false;
  @Output() valueChanged = new EventEmitter<any>();

  public onChange(value: any): void {
    if (this.disabled) return;
    this.valueChanged.emit(value);
  }
}
